import React from "react";
import { Link } from "react-router-dom";
import {
  WEBSITE_PROJECTS,
  SOFTWARE_PROJECTS,
  SOFTWARE_ACCESS_NOTE,
} from "../../constants/portfolioProjects";

const ProjectCard = ({ project, isContactOnly = false }) =>
{
    const content = (
      <>
        <div className="salv-all-image">
          <img src={project.image} alt={project.title} />
        </div>
        <div className="salv-all-conetent">
          <h3 className="mb-0 salv-all-title w-text inter-font-700">
            {project.title}
          </h3>
          <span className="salv-all-deatils sm-font">{project.category}</span>
          {isContactOnly && (
            <span className="salv-all-deatils sm-font portfolio-contact-note">
              contact admin for details
            </span>
          )}
        </div>
      </>
    );

    if (isContactOnly) {
      return (
        <div className="all-content-wrap detail-page portfolio-project-card portfolio-project-private">
          {content}
        </div>
      );
    }

    return (
      <a
        href={project.url}
        target="_blank"
        rel="noreferrer"
        className="all-content-wrap detail-page portfolio-project-link"
      >
        {content}
      </a>
    );
};

const PortfolioGrid = () =>
{
    return (
      <div className="salv-tab-filters">
        <div className="portfolio-section-heading">
          <h3 className="salv-about-personla-title dark-about-personal-title mb-0 w-text sm-md-font inter-font-700">
            websites
          </h3>
        </div>
        <div className="salv-tab-content-box row">
          <div className="col-lg-12 salv-tab-content content activ">
            <div className="salv-all-content row">
              {WEBSITE_PROJECTS.map((project) => (
                <div
                  key={project.id}
                  className="col-12 col-sm-6 col-md-6 col-lg-4 portfolio-col"
                >
                  <ProjectCard project={project} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="portfolio-section-heading portfolio-section-heading-spaced">
          <h3 className="salv-about-personla-title dark-about-personal-title mb-0 w-text sm-md-font inter-font-700">
            software systems
          </h3>
        </div>
        <p className="portfolio-access-note dark-sec-color inter-font-400 sm-md-font-two">
          {SOFTWARE_ACCESS_NOTE}{" "}
          <Link to="/contact" className="portfolio-contact-admin-link">
            Contact admin
          </Link>
        </p>
        <div className="salv-tab-content-box row">
          <div className="col-lg-12 salv-tab-content content activ">
            <div className="salv-all-content row">
              {SOFTWARE_PROJECTS.map((project) => (
                <div
                  key={project.id}
                  className="col-12 col-sm-6 col-md-6 col-lg-4 portfolio-col"
                >
                  <ProjectCard project={project} isContactOnly />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
};

export default PortfolioGrid;
